// bs-provider-preview-v5
import StagingProviderEmailTest from './StagingProviderEmailTest';
import React, { useState } from 'react';
import './StagingApprovalReview.css';

const CHECKS = [
  ['business','Business details','Complete your business name and location.'],
  ['services','Services','Add the services clients can book.'],
  ['gallery','Gallery','Add clear photos showcasing your work.'],
  ['policy','Booking policy','Set your booking and cancellation policy.'],
  ['availability','Availability','Set your working hours and available appointments.'],
];
const LOOKUP = {
  business:['business_profile'],
  services:['services'], gallery:['gallery'],
  policy:['booking_policy'], availability:['availability']
};
const isComplete = (checks,key) => LOOKUP[key].some(k=>checks && checks[k]===true);
const safe = (v,fallback='Not provided') => String(v??'').trim() || fallback;
export default function StagingApprovalReview({provider,onClose}) {
  const [screen,setScreen]=useState('review');
  const [additional,setAdditional]=useState('');
  const [showProvider,setShowProvider]=useState(false);
  const missing=CHECKS.filter(([key])=>!isComplete(provider.checklist,key));
  const name=safe(provider.businessName||provider.providerName,'Provider');
  const email=safe(provider.email);
  const subject='Finish setting up your Beauty Spot profile';
  const instructions=missing.map(([,label,instruction])=>`• ${label}: ${instruction}`).join('\n\n');
  const body=[`Hi ${name},`,
    missing.length ? 'There are a few steps left to complete your Beauty Spot profile:' : 'Thank you for submitting your Beauty Spot profile. Your application is awaiting review.',
    ...(missing.length?[instructions]:[]),
    missing.length?'Please complete these steps in the Beauty Spot app. Your profile will remain hidden until approved.':'We will review your application and contact you if anything further is required.',
    ...(additional.trim()?[additional.trim()]:[]),'The Beauty Spot team'].join('\n\n');
  const payment=provider.paymentSetup;
  const paymentLabel=payment?.connected===true?'Connected':payment?.connected===false?'Not connected':'Not verified';
  return <div className="bsp-overlay" onClick={onClose}><aside className="bsp-drawer bsar-drawer" role="dialog" aria-modal="true" aria-label={`Review ${name}`} onClick={e=>e.stopPropagation()}>
    <button className="bsp-close" type="button" aria-label="Close" onClick={onClose}>×</button>
    <div className="bsar-kicker">BEAUTY SPOT ADMIN</div>
    <h2>{screen==='preview'?'Preview setup reminder':`Review · ${name}`}</h2>
    <button className="bsar-back" type="button" onClick={()=>screen==='preview'?setScreen('review'):onClose()}>{screen==='preview'?'← Edit reminder':'← Back to provider list'}</button>
    {screen==='review'?<>
      <h3>What's left to complete</h3>
      <p className="bsar-muted">These checks reflect recorded provider information. Payment setup is optional and does not prevent approval.</p>
      <div className="bsar-checks">{CHECKS.map(([key,label])=>{const done=isComplete(provider.checklist,key);return <div className={`bsar-check ${done?'done':'missing'}`} key={key}><span aria-hidden="true">{done?'✓':'○'}</span><div><strong>{label}</strong><small>{done?'Complete':'Still to complete'}</small></div></div>})}
        <div className="bsar-check optional"><span aria-hidden="true">○</span><div><strong>Payment setup <em>Optional</em></strong><small>{paymentLabel}</small></div></div>
      </div>
      <p className="bsar-summary">{missing.length?`Still to complete: ${missing.map(x=>x[1]).join(', ')}`:'All mandatory setup checks are complete.'}</p>
      <h3>Setup reminder email</h3>
      <p className="bsar-muted">Generated from the missing mandatory requirements. Test emails go only to toluadedoyin@hotmail.co.uk.</p>
      <p className="bsar-muted"><b>To:</b> {email}<br/><b>Subject:</b> {subject}</p>
      <div className="bsar-email">{body}</div>
      <label className="bsar-label" htmlFor="bsar-additional">Additional information (optional)</label>
      <textarea id="bsar-additional" value={additional} onChange={e=>setAdditional(e.target.value)} maxLength={2000} placeholder="Add any specific guidance for this provider…" rows={4}/>
      <div className="bs-provider-actions"><button className="bsar-primary" type="button" onClick={()=>setScreen('preview')}>Preview reminder &amp; test email →</button><small>Test inbox: toluadedoyin@hotmail.co.uk</small></div>
    </>:<>
      <p className="bsar-muted"><b>To:</b> {email}<br/><b>Subject:</b> {subject}</p>
      <div className="bsar-email">{body}</div>
      <StagingProviderEmailTest provider={provider} subject={subject} body={body} label="Preview and send test email" initialOpen initialPreview onClose={()=>setScreen('review')}/>
      <p className="bsar-muted">Send this test only to toluadedoyin@hotmail.co.uk. Provider status stays unchanged.</p>
      <button className="bsar-primary" type="button" onClick={()=>setScreen('review')}>Edit reminder</button>
    </>}
  </aside></div>;
}
